<script setup>
import { computed, onMounted } from 'vue'
import { Icon } from '@iconify/vue'

const props = defineProps({
    show: Boolean,
    message: String,
    type: {
        type: String,
        default: 'success' // success, warning, danger
    },
    duration: {
        type: Number,
        default: 12000
    }
})

const emit = defineEmits(['close'])

const typeStyles = computed(() => {
    switch (props.type) {
        case 'success':
            return 'bg-emerald-50 border-emerald-200 text-emerald-800'
        case 'warning':
            return 'bg-amber-50 border-amber-200 text-amber-800'
        case 'danger':
            return 'bg-red-50 border-red-200 text-red-800'
        default:
            return 'bg-blue-50 border-blue-200 text-blue-800'
    }
})

const iconName = computed(() => {
    switch (props.type) {
        case 'success': return 'tabler:circle-check'
        case 'warning': return 'tabler:alert-triangle'
        case 'danger': return 'tabler:alert-circle'
        default: return 'tabler:info-circle'
    }
})

const iconColor = computed(() => {
    switch (props.type) {
        case 'success': return 'text-emerald-500'
        case 'warning': return 'text-amber-500'
        case 'danger': return 'text-red-500'
        default: return 'text-blue-500'
    }
})

// Auto-close logic could be handled here or in the parent. 
// Let's keep it simple and handle it in the parent to avoid side effects in a simple component.
</script>

<template>
    <Transition name="toast">
        <div v-if="show" class="fixed top-5 right-4 xl:top-6 xl:right-6 z-[9999] w-full max-w-sm xl:w-auto xl:max-w-max">
            <div :class="['flex items-center justify-between gap-3 p-4 rounded-lg border shadow-xl backdrop-blur-md', typeStyles]">
                <div class="flex items-center gap-3">
                    <div :class="['', iconColor]">
                        <Icon :icon="iconName" class="w-6 h-6" />
                    </div>
                    <div class="text-sm font-bold xl:whitespace-nowrap">
                        {{ message }}
                    </div>
                </div>
                <button @click="$emit('close')" class="p-1 hover:bg-black/5 rounded-full transition-colors">
                    <Icon icon="tabler:x" class="w-4 h-4 opacity-50" />
                </button>
            </div>
        </div>
    </Transition>

    <!-- Para generar conexión de alerts -->
    <!-- const showAlert = (message, type = 'success', duration = 6000) => {
    alertData.value = { show: true, message, type }
    setTimeout(() => {
        alertData.value.show = false
    }, duration)
} -->

</template>

<style scoped>
.toast-enter-active {
    animation: toast-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.toast-leave-active {
    animation: toast-out 0.3s ease-in;
}

@keyframes toast-in {
    from {
        opacity: 0;
        transform: translateX(100%) scale(0.9);
    }

    to {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
}

@keyframes toast-out {
    from {
        opacity: 1;
        transform: translateX(0) scale(1);
    }

    to {
        opacity: 0;
        transform: translateX(20%) scale(0.95);
    }
}
</style>
